// lib
import React from 'react'

// components
import PageTitle from 'src/components/header/main/page_title/page_title'

// helpers
import { textResources } from 'src/lang/de'

const PageTitleGroupFeed: React.FC<{ title?: string | undefined }> = ({ title }) => {
  return (
    <PageTitle
      text={textResources.pageTitles.groupFeed(title ?? '')}
    />
  )
}

export default PageTitleGroupFeed
